import { render, staticRenderFns } from "./Func10Detalhe.vue?vue&type=template&id=a4e3cf84"
import script from "./Func10Detalhe.vue?vue&type=script&lang=js"
export * from "./Func10Detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports